import { useCanvasClone } from './useCanvasClone';
import useFetchedEstimate from './useFetchedEstimate';

import { getIsDirtyState } from '~/core/helpers';
import { useAppSelector } from '~/redux/hooks';
import { selectSelectedColorId } from '~/redux/slices/color';

export const useCanvasImage = () => {
  const { canvasJpegUrl } = useCanvasClone();
  const { fetchedEstimate } = useFetchedEstimate();
  const isDirty = getIsDirtyState();
  const selectedColorId = useAppSelector(selectSelectedColorId);
  const estimateDrawingUrl = fetchedEstimate?.estimateDrawingUrl;

  // Check if color has changed from fetched estimate
  // This ensures we use fresh canvas image after color change, not cached server image
  const fetchedColorId = fetchedEstimate?.estimateData?.color?.productId;
  const hasColorChanged =
    fetchedColorId !== undefined &&
    selectedColorId !== undefined &&
    fetchedColorId !== selectedColorId;

  // Use canvas image if dirty OR if color has changed (visual change)
  const shouldPrioritizeUrl =
    !!estimateDrawingUrl && !isDirty && !hasColorChanged;

  return {
    canvasJpeg: shouldPrioritizeUrl
      ? estimateDrawingUrl
      : (canvasJpegUrl ?? estimateDrawingUrl ?? ''),
  };
};
